<tg-row class="summary-page-open-homes-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Open homes</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-open-homes-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit open homes</a
        >
    </tg-col>
</tg-row>
<tg-row *ngIf="openHomeTimes.length === 0">
    <tg-col>
        <span class="summary-page-open-homes-section__content-value">
            No open home time added
        </span>
    </tg-col>
</tg-row>
<tg-row *ngIf="openHomeTimes.length > 0">
    <tg-col>
        <ul tgList2>
            <li *ngFor="let o of openHomeTimes; index as i">
                {{ o.date | date: 'dd/MM/yyyy' }},
                {{ o.startTime | tmTimeFromNumber }} -
                {{ o.endTime | tmTimeFromNumber }}
            </li>
        </ul>
    </tg-col>
</tg-row>
